import React, { FC } from 'react';
// mui components
import { Grid, Typography, Dialog } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// api
import { useDeleteSchedulePhaseMutation } from 'redux-store/api/schedule-phases';
import { useDeleteSchedulePhaseItemMutation } from 'redux-store/api/schedule-phases-items';
// styles
import { deletePhaseModalStyles } from './styles';

interface OwnProps {
  itemId?: number | null;
  phaseId?: number | null;
  isPhase?: boolean;
  projectId: string;
  gantt?: boolean;
  ganttItemId?: string;
  closePhaseModal?: () => void;
  closePhaseItemModal?: () => void;
  closeItemModal?: () => void;
  handleDeleteTask?: (id: string, isPhase?: boolean) => void;
  fromItemModal?: boolean;
  handleAllowUpdateProject?: () => void;
  handleCloseParentMondal?: () => void;
}

const DeleteItemModal: FC<OwnProps> = ({
  itemId,
  phaseId,
  isPhase,
  projectId,
  gantt,
  fromItemModal,
  ganttItemId,
  closeItemModal,
  closePhaseModal,
  handleDeleteTask,
  closePhaseItemModal,
  handleAllowUpdateProject,
  handleCloseParentMondal,
}) => {
  const [deleteSchedulePhase, { isLoading: isDeletePhaseLoading }] =
    useDeleteSchedulePhaseMutation();
  const [deleteSchedulePhaseItem, { isLoading: isDeletePhaseItemLoading }] =
    useDeleteSchedulePhaseItemMutation();

  const handleSubmit = async () => {
    if (!isPhase && itemId) {
      deleteSchedulePhaseItem({ id: itemId, projectId: Number(projectId) })
        .unwrap()
        .then(() => {
          if (fromItemModal) {
            closeItemModal();
          }

          if (!!handleDeleteTask) {
            if (gantt && !!ganttItemId) {
              handleDeleteTask(ganttItemId);
            } else {
              handleDeleteTask(String(itemId));
            }
          }

          if (!!handleAllowUpdateProject) {
            setTimeout(() => {
              handleAllowUpdateProject();
            }, 300);
          }

          if (!!handleCloseParentMondal) {
            handleCloseParentMondal();
          }
        })
        .finally(() => {
          closePhaseItemModal();
        });
    } else if (isPhase && phaseId) {
      deleteSchedulePhase({ id: phaseId, projectId: Number(projectId) })
        .unwrap()
        .then(() => {
          if (!!handleDeleteTask) {
            if (gantt && !!ganttItemId) {
              handleDeleteTask(ganttItemId);
            } else {
              handleDeleteTask(String(phaseId), true);
            }
          }

          if (!!handleAllowUpdateProject) {
            setTimeout(() => {
              handleAllowUpdateProject();
            }, 300);
          }

          if (!!handleCloseParentMondal) {
            handleCloseParentMondal();
          }
        })
        .finally(() => {
          closePhaseModal();
        });
    }
  };

  return (
    <Dialog
      open={isPhase ? !!phaseId : !!itemId}
      onClose={isPhase ? closePhaseModal : closePhaseItemModal}
      sx={deletePhaseModalStyles.modal}
    >
      <Grid sx={deletePhaseModalStyles.titleContainer}>
        <Grid container alignItems="center">
          <Typography sx={deletePhaseModalStyles.title}>
            {isPhase ? 'Delete Phase Item' : 'Delete Schedule Item'}
          </Typography>

          <Typography sx={deletePhaseModalStyles.subtitle}>
            {isPhase
              ? 'Are you sure you would like to delete this phase, along with the schedule items associated to it?'
              : 'Are you sure you would like to delete this schedule item?'}
          </Typography>
        </Grid>
      </Grid>

      <Grid sx={deletePhaseModalStyles.buttonsContainer}>
        <LoadingButton
          loading={isDeletePhaseLoading || isDeletePhaseItemLoading}
          variant="outlined"
          onClick={isPhase ? closePhaseModal : closePhaseItemModal}
          sx={deletePhaseModalStyles.cancelButton}
        >
          Cancel
        </LoadingButton>
        <LoadingButton
          color="error"
          loading={isDeletePhaseLoading || isDeletePhaseItemLoading}
          variant="contained"
          onClick={handleSubmit}
          sx={deletePhaseModalStyles.saveButton}
        >
          Confirm
        </LoadingButton>
      </Grid>
    </Dialog>
  );
};

export default DeleteItemModal;
